module.exports = __webpack_public_path__ + "static/img/search_subcat_item_02_show.1d3eddb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/shared/assets/images/release/search_subcat_item_02_show.jpg
// module id = 2mu/
// module chunks = 0